export enum RequestTrackingType {
  SPOT_RATE,
  OUTRIGHT_RATE,
}

export namespace RequestTrackingType {
  let elements = [RequestTrackingType.SPOT_RATE, RequestTrackingType.OUTRIGHT_RATE];
  let alias = "com.bcdfx.model.RequestTrackingType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
